var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"screen"}},[_c('NavigationBar',{staticClass:"navigationBar"}),_c('GameArea'),_c('PopupOverlay'),_c('PopupLayer')],1),_c('div',{attrs:{"id":"print"}},[_c('PrintPage')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }